<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md5>
        <v-card flat color="transparent">
          <v-card-text class="text-center">
            <h1 class="display-2 py-4">Welcome to Context</h1>
            <template v-if="checkingToken">
              <v-skeleton-loader></v-skeleton-loader>
            </template>
            <template v-else-if="invite && invite.status == 'open'">
              <p class="title pb-4">You've been invited to join {{ invite.workspace.name }}!</p>
              <auth id="mainAuth" :inviteId="inviteId"></auth>
            </template>
            <template v-else>
              <p class="title pb-4">Unfortunately, your invitation has expired.</p>
              <p>
                You can <a :href="/login/">SIGN UP</a> on your own. To receive a new invitation ask
                someone from the workspace you wish to join.
              </p>
            </template>
          </v-card-text>
        </v-card>
        <v-overlay :opacity="0.7" :value="isUser" style="text-align: center;">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
          <div class="headline">Joining Workspace</div>
        </v-overlay>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Auth from '@/components/Auth';
// import { mapGetters, mapActions } from 'vuex';
export default {
  components: { Auth },
  props: ['inviteId'],
  data() {
    return {
      checkingToken: true,
      invite: null
    };
  },
  mounted() {
    console.log('check invite');
    this.checkInvite({ inviteId: this.inviteId })
      .then(result => {
        console.log(result)
        this.invite = result;
        this.checkingToken = false;
      })
      .catch(e => {
        console.log(e);
        this.checkingToken = false;
      });
  },
  computed: {
    ...mapGetters('auth', ['isUser'])
  },
  methods: {
    ...mapActions('auth', ['checkInvite'])
  }
};
</script>

<style></style>
